// extracted by mini-css-extract-plugin
export default {"backdrop":"ResizeableNavLayout_backdrop__FY83C","overlay":"ResizeableNavLayout_overlay__ZnDvT"};